import { Users } from 'lucide-react'
import type { ConciergeHomeTeamMember } from '../lib/api'

// The three-person team roster from the live team brief. Blurbs are the
// team's OWN words — rendered verbatim, never paraphrased or reordered.
export function HomeTeamCard({ team }: { team: ConciergeHomeTeamMember[] }) {
  if (team.length === 0) return null

  return (
    <section aria-label="Your team" className="mb-5">
      <h2 className="text-lg font-semibold text-navy flex items-center gap-2 mb-3">
        <Users className="w-5 h-5 text-brass" aria-hidden="true" />
        Your team
      </h2>
      <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm divide-y divide-gray-100">
        {team.map((member) => (
          <div key={member.role} className="py-2 first:pt-0 last:pb-0">
            <p className="text-sm font-medium text-navy">{member.role}</p>
            <p className="text-xs text-gray-600 mt-0.5 whitespace-pre-wrap break-words">
              {member.blurb}
            </p>
          </div>
        ))}
      </div>
    </section>
  )
}
